// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Option {
  box-sizing: border-box;
  background-color: var(--primary-color);
  border: 1px solid transparent;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
  border-radius: 0.375rem;
  transition: all 150ms ease-in-out;
  cursor: pointer;
  border-color: var(--border-color);
}
.Option.primary {
  background-color: var(--primary-color);
  color: var(--text-color);
}
.Option.primary:hover {
  background-color: var(--primary-color-light);
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: var(--border-color);
}
.Option.primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: var(--border-color);
}
.Option.primary:active {
  background-color: var(--primary-color-light);
  border-color: var(--border-color);
}
.Option.secondary {
  background-color: var(--secondary-color);
  color: var(--text-color);
}
.Option.secondary:hover {
  background-color: var(--secondary-color-light);
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: var(--border-color);
}
.Option.secondary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: var(--border-color);
}
.Option.secondary:active {
  background-color: var(--secondary-color-light);
  border-color: var(--border-color);
}
.Option[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/client/HoosatUI/src/Elements/Form/Option/Option.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;AACA;EACE,4CAA4C;EAC5C,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;AACnC;AACA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;AACA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;AACA;EACE,8CAA8C;EAC9C,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;AACnC;AACA;EACE,8CAA8C;EAC9C,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["@import '../../../theme.css';\n\n.Option {\n  box-sizing: border-box;\n  background-color: var(--primary-color);\n  border: 1px solid transparent;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  border-radius: 0.375rem;\n  transition: all 150ms ease-in-out;\n  cursor: pointer;\n  border-color: var(--border-color);\n}\n.Option.primary {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n}\n.Option.primary:hover {\n  background-color: var(--primary-color-light);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: var(--border-color);\n}\n.Option.primary:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: var(--border-color);\n}\n.Option.primary:active {\n  background-color: var(--primary-color-light);\n  border-color: var(--border-color);\n}\n.Option.secondary {\n  background-color: var(--secondary-color);\n  color: var(--text-color);\n}\n.Option.secondary:hover {\n  background-color: var(--secondary-color-light);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: var(--border-color);\n}\n.Option.secondary:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: var(--border-color);\n}\n.Option.secondary:active {\n  background-color: var(--secondary-color-light);\n  border-color: var(--border-color);\n}\n.Option[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
